// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_em-a";
export var fulfillmentFormRail = "_em-9";
export var headerTitleRow = "_em-c";
export var orderDetailsWrapper = "_em-7";
export var orderLinkTrigger = "_em-2";
export var paymentInformationGrid = "_em-h";
export var paymentSummaryColumn = "_em-i";
export var shipmentContainer = "_em-b";
export var shipmentDetailsMainPane = "_em-8";
export var shipmentNavigationCard = "_em-5";
export var shipmentNavigationRail = "_em-3";
export var shipmentNavigationRailHeader = "_em-4";
export var shipmentSummaryFact = "_em-e";
export var shipmentSummaryGrid = "_em-d";
export var shipmentSummaryMetadataRow = "_em-f";
export var shipmentSummaryTags = "_em-g";
export var shipmentWorkspace = "_em-0";
export var shipmentWorkspaceContent = "_em-6";
export var shipmentWorkspaceHeader = "_em-1";